import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ResultsOfAppsRaw = React.lazy(() => import(/* webpackChunkName: "ResultsOfApps" */ './ResultsOfApps'));
export const ResultsOfApps = () => (React.createElement(Page, { title: "Appearance Results", description: "Appearance Results" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ResultsOfAppsRaw, null)))));
